module.exports = __webpack_public_path__ + "img/ecopoliza.d43a7bef.jpg";